var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { InstantCollapsible } from "sb-resp-ui";
import { SecondaryHeading } from "../../components/SecondaryHeading";
import { HeadingTitle } from "../../components/HeadingTitle";
var SecondaryHeadingContent = /** @class */ (function (_super) {
    __extends(SecondaryHeadingContent, _super);
    function SecondaryHeadingContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecondaryHeadingContent.prototype.renderSubheading = function () {
        return React.createElement(SecondaryHeading, { key: "subheading-" + this.props.id, cardType: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }));
    };
    SecondaryHeadingContent.prototype.render = function () {
        return (React.createElement(InstantCollapsible, { key: "collapse-subheading-" + this.props.id, initiallyExpanded: this.props.shouldExpand, trigger: this.renderSubheading(), content: React.createElement(React.Fragment, null, this.props.children) }));
    };
    return SecondaryHeadingContent;
}(React.PureComponent));
export { SecondaryHeadingContent };
//# sourceMappingURL=SecondaryHeadingContent.js.map